module.exports = __webpack_public_path__ + "img/1.2a806522.png";